import React, { FC, useState } from 'react';
import { Form, Select, Tag } from 'antd';
import { usePermissions } from '~/hooks';
import { useEmployeesRoles } from '~/hooks/employees';
import { getRoleColor } from '~/utils/employees';

const { Option } = Select;

const tagRender = (props: any) => {
  const { label, value, closable, onClose } = props;

  return (
    <Tag color={getRoleColor(value)} closable={closable} onClose={onClose}>
      {label}
    </Tag>
  );
};

interface RolesInputProps {
  initialRoles: string[] | undefined;
  label: string;
  isSelf: boolean;
}

const RolesInput: FC<RolesInputProps> = (props) => {
  const { initialRoles, label, isSelf } = props;

  const [selectedItems, setSelectedItems] = useState<string[]>(initialRoles ?? []);

  const hasAccess = usePermissions('business.employee.assign manager and administrator role');
  const isDisabledByPermissions = (role: string) =>
    role === 'BUSINESS_ADMINISTRATOR' || role === 'BUSINESS_MANAGER' ? !hasAccess : false;

  const { data: employeeRoles } = useEmployeesRoles();

  const options = employeeRoles?.map(({ role, name }) => {
    if (role === 'BUSINESS_ADMINISTRATOR') {
      return (
        <Option
          value={role}
          disabled={
            isDisabledByPermissions(role) || selectedItems.includes('BUSINESS_MANAGER') || isSelf
          }
        >
          {name}
        </Option>
      );
    }
    if (role === 'BUSINESS_MANAGER') {
      return (
        <Option
          value={role}
          disabled={
            isDisabledByPermissions(role) ||
            selectedItems.includes('BUSINESS_ADMINISTRATOR') ||
            isSelf
          }
        >
          {name}
        </Option>
      );
    }
    return (
      <Option value={role} disabled={isDisabledByPermissions(role)}>
        {name}
      </Option>
    );
  });

  return (
    <Form.Item name={'roles'} label={label}>
      <Select
        mode="multiple"
        showArrow
        tagRender={tagRender}
        value={selectedItems}
        onChange={(value: any) => setSelectedItems(value)}
      >
        {options}
      </Select>
    </Form.Item>
  );
};

export default RolesInput;
